var map = {
	"./decidim/avatar-multiuser.png": 666,
	"./decidim/brands/google.svg": 2485,
	"./decidim/cc-badge.png": 228,
	"./decidim/decidim-logo.svg": 5608,
	"./decidim/default-avatar.svg": 3504,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 5964,
	"./decidim/icons.svg": 8491,
	"./decidim/pattern.png": 972,
	"./decidim/placeholder-card-g.svg": 313,
	"./decidim/placeholder-card-l.svg": 8658,
	"./decidim/placeholder.jpg": 6561,
	"./decidim/remixicon.symbol.svg": 9557,
	"./decidim/vendor/leaflet/layers-2x.png": 1492,
	"./decidim/vendor/leaflet/layers.png": 8739,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 9310,
	"./decidim/vendor/leaflet/marker-icon.png": 2197,
	"./decidim/vendor/leaflet/marker-shadow.png": 1626,
	"./decidim/vendor/social-share-button/douban.svg": 9572,
	"./decidim/vendor/social-share-button/email.svg": 9505,
	"./decidim/vendor/social-share-button/facebook.svg": 5271,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 6937,
	"./decidim/vendor/social-share-button/hacker_news.svg": 7489,
	"./decidim/vendor/social-share-button/linkedin.svg": 5057,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 9218,
	"./decidim/vendor/social-share-button/pinterest.svg": 935,
	"./decidim/vendor/social-share-button/reddit.svg": 6827,
	"./decidim/vendor/social-share-button/telegram.svg": 9006,
	"./decidim/vendor/social-share-button/tumblr.svg": 253,
	"./decidim/vendor/social-share-button/twitter.svg": 7024,
	"./decidim/vendor/social-share-button/vkontakte.svg": 2814,
	"./decidim/vendor/social-share-button/wechat.svg": 2553,
	"./decidim/vendor/social-share-button/whatsapp.svg": 4465,
	"./decidim/vendor/social-share-button/x.svg": 3961,
	"./decidim/vendor/social-share-button/xing.svg": 2727
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6479;